import { render, staticRenderFns } from "./ProjectDetail.vue?vue&type=template&id=7ab5b9cd&scoped=true"
import script from "./ProjectDetail.vue?vue&type=script&lang=js"
export * from "./ProjectDetail.vue?vue&type=script&lang=js"
import style0 from "./ProjectDetail.vue?vue&type=style&index=0&id=7ab5b9cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab5b9cd",
  null
  
)

export default component.exports